import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import AshdaleLogoSVG from '../../assets/ashdale-logo.svg';

const {FiMail, FiPhone, FiMapPin} = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-black text-white border-t border-primary-500/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src={AshdaleLogoSVG} alt="Ashdale Analytics" className="h-10" />
            </div>
            <p className="text-secondary-400 mb-4 max-w-md">
              Empowering your financial future with comprehensive planning tools and expert insights. Make informed decisions about retirement, home purchases, and education funding.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-secondary-400">
                <SafeIcon icon={FiMail} className="w-4 h-4 text-primary-500" />
                <span>info@ashdaleanalytics.com</span>
              </div>
              <div className="flex items-center space-x-2 text-secondary-400">
                <SafeIcon icon={FiPhone} className="w-4 h-4 text-primary-500" />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="flex items-center space-x-2 text-secondary-400">
                <SafeIcon icon={FiMapPin} className="w-4 h-4 text-primary-500" />
                <span>123 Financial District, New York, NY 10004</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-500">Calculators</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/calculators/retirement" className="text-secondary-400 hover:text-primary-500 transition-colors">
                  Retirement Planning
                </Link>
              </li>
              <li>
                <Link to="/calculators/home" className="text-secondary-400 hover:text-primary-500 transition-colors">
                  Home Purchase
                </Link>
              </li>
              <li>
                <Link to="/calculators/education" className="text-secondary-400 hover:text-primary-500 transition-colors">
                  Education Planning
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-primary-500">Account</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/login" className="text-secondary-400 hover:text-primary-500 transition-colors">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-secondary-400 hover:text-primary-500 transition-colors">
                  Create Account
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-secondary-400 hover:text-primary-500 transition-colors">
                  My Portfolio
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-500/30 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-secondary-400 text-sm">
              © 2024 Ashdale Analytics. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-secondary-400 hover:text-primary-500 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-secondary-400 hover:text-primary-500 text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-secondary-400 hover:text-primary-500 text-sm transition-colors">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;